if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.ensureErrorHtml();

        if (!this.hasAttribute('available')) return;
        this.fetchAvailability(this.dataset.variantId);
      }

      ensureErrorHtml() {
        if (this.errorHtml) return;
        const template = this.querySelector('template');
        const first = template?.content?.firstElementChild;
        if (first) this.errorHtml = first.cloneNode(true);
      }

      clearPreviewKeepTemplate() {
        Array.from(this.children).forEach((child) => {
          if (child.tagName !== 'TEMPLATE') child.remove();
        });
      }

      fetchAvailability(variantId) {
        this.ensureErrorHtml();
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(() => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.ensureErrorHtml();
        if (!this.errorHtml) return;

        this.clearPreviewKeepTemplate();
        this.appendChild(this.errorHtml.cloneNode(true));

        const button = this.querySelector('button');
        if (button) button.addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();

        const preview = sectionInnerHTML?.querySelector('pickup-availability-preview');
        if (!preview) {
          this.clearPreviewKeepTemplate();
          this.removeAttribute('available');
          return;
        }

        this.clearPreviewKeepTemplate();
        this.insertAdjacentHTML('afterbegin', preview.outerHTML);
        this.setAttribute('available', '');

        const drawerEl = sectionInnerHTML.querySelector('pickup-availability-drawer');
        if (drawerEl) document.body.appendChild(drawerEl);

        const button = this.querySelector('button');
        if (button) {
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer')?.show(evt.target);
          });
        }
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        const closeBtn = this.querySelector('button');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            this.hide();
          });
        }

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        window.removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        window.trapFocus(this);
      }
    }
  );
}
